import { Alert } from '@material-ui/lab';
import React from 'react';
import JSONInput from 'react-json-editor-ajrm';
import { BackButton, PrimaryButton, TextField } from '../../components/AtomComponents';
import { localeEn } from '../ConfigTenant/ConfigTenant';
import { Wait } from './SchemaSync';
import QueryReviewConfirmationDialog from './QueryReviewConfirmationDialog';
import useVerticalSync, { IProps } from './useVerticalSync';

const VerticalSyncV2 = ({ syncFor }: IProps) => {
  const {
    environment, setEnvironment, release, setRelease, processState, setProcessState, previewState,
    reviewQueriesConfirmationDialog, reviewData,
    schemaSync, openReviewQueriesConfirmationDialog, closeReviewQueriesConfirmationDialog, onApprove, confirm
  } = useVerticalSync({ syncFor });

  const dialogContent = (
    <>This is to sync across <b>{environment?.toUpperCase()}</b>. Do you really want to execute it?</>
  );

  return (
    <>
      <div className="cell small-6 medium-6 px-one-line-data margin-bottom-2">
        <BackButton />
        <h3 className="small-12 margin-bottom-1">Sync across Environment V2</h3>
      </div>
      {processState === 0 && (
        <>
          <TextField
            label="Environment"
            size="small"
            value={environment}
            onChange={(e) => {
              setEnvironment(e.target.value);
            }}
            placeholder="Environment"
            className="margin-right-1"
          />
          <TextField
            label="Release"
            size="small"
            value={release}
            onChange={(e) => {
              setRelease(e.target.value);
            }}
            placeholder="Release"
            className="margin-right-1"
          />

          <PrimaryButton
            style={{ marginRight: '10px' }}
            disabled={!environment.length || !release}
            onClick={openReviewQueriesConfirmationDialog}>
            Review Queries and Approve
          </PrimaryButton>

          <PrimaryButton
            disabled={!environment.length || !release}
            onClick={() => {
              confirm({
                content: dialogContent,
                confirmText: 'Sync',
                cancelText: 'Cancel',
                onConfirm: schemaSync,
              });
            }}>
            Sync
          </PrimaryButton>
        </>
      )}
      {processState === 1 && <Wait />}
      {processState === 2 && (
        <>
          <div className="margin-bottom-3">
            <JSONInput
              id={`${syncFor}-vertical-jsonEditor`}
              theme="light_mitsuketa_tribute"
              locale={localeEn}
              placeholder={previewState}
              height="550px"
              width="100%"
              viewOnly={true}
              style={{ body: { fontSize: '16px' } }}
            />
          </div>
          <Alert severity="success" className="margin-bottom-3">
            Schema sync completed!
          </Alert>
          <PrimaryButton onClick={() => setProcessState(0)}>Restart</PrimaryButton>
        </>
      )}

      <QueryReviewConfirmationDialog
        dialogState={{
          isOpen: reviewQueriesConfirmationDialog,
          meta: { environment, release },
          reviewData,
        }}
        actions={{
          onClose: closeReviewQueriesConfirmationDialog,
          onApprove,
          reviewQueries: openReviewQueriesConfirmationDialog,
        }}
      />
    </>
  );
};

export default VerticalSyncV2;
